import { useMutation, useQueryClient } from '@tanstack/react-query'

import { initFilesSdk } from '../filesSdk'

export const useTrashItemsMutation = () => {
  const { filesSdk, success } = initFilesSdk()
  const queryClient = useQueryClient()

  const useTrashItems = useMutation({
    mutationFn: async (items: number[]) => {
      if (!success) {
        return
      }

      if (!filesSdk) return

      await filesSdk.items.trash(items)
      await queryClient.invalidateQueries({ queryKey: ['files-list'] })
      return
    }
  })

  return useTrashItems
}
